import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './styles.scss';

const CarouselSection = ({ section }) => {
    const { header, images } = section;

    // Sort images by sequence
    const sortedImages = images ? [...images].sort((a, b) => a.sequence - b.sequence) : [];

    return (
        <div className="carousel-section">
            {header && <h2 className="carousel-header">{header}</h2>}

            <div className="carousel-container">
                <Swiper
                    spaceBetween={10}
                    slidesPerView={window.innerWidth > 768 ? 4 : 1}
                    modules={[Navigation]}
                    navigation={true}
                >
                    {sortedImages.map((image) => (
                        <SwiperSlide key={image.id}>
                            <div className="carousel-item">
                                <div className="carousel-item-image">
                                    <img
                                        src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/carousel/${image.fileName}&width=400&height=500&quality=90&format=webp`}
                                        alt={image.title || 'Carousel image'}
                                    />
                                    <p className="carousel-item-title">{image.title || 'Project Name.'}</p>
                                    <p className="carousel-item-desc">
                                        {image.description}
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CarouselSection;
